var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "chevron-left_svg__path-1",
    d: "M8 14.582 17.467 4 20 6.886Q8.157 20.012 8 20q-.163.006-12-13.114L-1.467 4z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-left_svg__chevron-left",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "chevron-left_svg__icons/chevron-left",
    transform: "translate(4)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chevron-left_svg__path-1",
    id: "chevron-left_svg__Shape",
    fill: "#000",
    fillRule: "nonzero",
    transform: "rotate(90 8 12)"
  })))));
};
export default SvgChevronLeft;